//Configuration paths
export const AppConfig = {
    login: 'login', //Login page
    logout: 'login' //Logout page
};

